import * as React from 'react';

import { Popover } from 'reactstrap';

import { hashCode } from 'common/utils/utils';

export interface FormHelpProps {
  text: string;
  id?: string;
}
export interface FormHelpState {
  isPopoverOpen: boolean;
}
export class FormHelp extends React.Component<FormHelpProps, {}> {
  state: FormHelpState = { isPopoverOpen: false };

  handleToggle = () => {
    this.setState({ isPopoverOpen: !this.state.isPopoverOpen });
  };

  handleShow = () => {
    this.setState({ isPopoverOpen: true });
  };

  handleHide = () => {
    this.setState({ isPopoverOpen: false });
  };

  render() {
    // generate a unique hashcode so we don't have to track component ids
    const id = this.props.id ? this.props.id : 'popover-help-' + hashCode(this.props.text);
    return (
      <span>
        <i
          style={{ marginLeft: 10 }}
          className="fa fa-info-circle"
          onMouseOver={this.handleShow}
          onMouseOut={this.handleHide}
          id={id}
        />
        <Popover placement="right" isOpen={this.state.isPopoverOpen} target={id}>
          {this.props.text}
        </Popover>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/FormHelp.tsx